import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { GetCacheKey } from '../../services/common/utils';
import Loadingcomponent from '../loader/loadingcomponent';
import ErrorMessage from '../messaging/errormessage';

const PromoSwiper = ({ psmItem }) => {
  const navigate = useNavigate();

  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
  } = useQuery(
    [
      GetCacheKey(psmItem?.uniqueid),
      psmItem?.method,
      JSON.parse(psmItem?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 300000,
      staleTime: 300000,
    }
  );

  if (isLoading || isFetching || !data) {
    // return <Loadingcomponent message={'Loading'} />;
    return <></>
  }

  if (error || isError || isLoadingError) {
    return <ErrorMessage message={'Invalid'} />;
  }

  const handlePromoBanner = (e, banner) => {
    e.preventDefault();

    if (banner?.url === 'passportcountries') {
      navigate('/passport-countries');
    } else if (banner?.url === 'roamingintl') {
      navigate('/roaming-rates');
    }
  };

  return (
    <div>
      {/* Commented for UI team reference */}
      {/* <div className="flex_grp_between mb-3">
          <h3 className="section_title_light mb-0">Promotions</h3>
          <a className="hyperlink">
            View All
            <img
              src={
                process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
              }
              alt=""
              title=""
            />
          </a>
        </div> */}
        <div className="flex_grp_between">
          <h3 className="section_title_light mb-0">{psmItem?.elementmeta?.title}</h3>
        </div>

      <Swiper
        className="promo_card_swiper_1 mb-30"
        spaceBetween={12}
        slidesPerView={1}
        onSlideChange={() => console.log('slide change')}
        onSwiper={(swiper) => console.log(swiper)}
      >
        {data?.response[0]?.banners?.map((banner, index) => {
          return (
            <SwiperSlide key={`index-${index}`}>
              <a href="#" onClick={(e) => handlePromoBanner(e, banner)}>
                <picture>
                  <img
                    // src={
                    //   banner?.path ||
                    //   process.env.PUBLIC_URL + '/assets/images/promo-banner.png'
                    // }
                    src={`${banner?.path + '?tmp=' + 't' + Date.now()}` ||
                    process.env.PUBLIC_URL + '/assets/images/promo-banner.png'
                  }
                    width="{100%}"
                    alt=""
                    title=""
                  />
                </picture>
              </a>
            </SwiperSlide>
          );
        })}

        {/* <SwiperSlide>
          <a href="#">
            <picture>
              <img
                src={process.env.PUBLIC_URL + '/assets/images/promo-banner.png'}
                width="{100%}"
                alt=""
                title=""
              />
            </picture>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="#">
            <picture>
              <img
                src={process.env.PUBLIC_URL + '/assets/images/promo-banner.png'}
                width="{100%}"
                alt=""
                title=""
              />
            </picture>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="#">
            <picture>
              <img
                src={process.env.PUBLIC_URL + '/assets/images/promo-banner.png'}
                width="{100%}"
                alt=""
                title=""
              />
            </picture>
          </a>
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
};
export default PromoSwiper;
